import { FETCH_STATUS, Props as RawProps } from '../RawSearchInput/RawSearchInput.types';

export type Props<T> = Omit<RawProps<T, true, true>, 'disableClearable' | 'multiple'>;

export const defaultProps = {
  fetchStatus: FETCH_STATUS.FULFILLED,
  minLengthToSearch: 0,
  showSelected: false,
};
